import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/app/app';
import './assets/style/index.scss';

// StrictMode only affects development builds: it double-invokes render and mounts
// to surface side effects that would misbehave under React's concurrent rendering.
createRoot(document.getElementById('app')).render(
	<StrictMode>
		<App />
	</StrictMode>
);
